import React from 'react';
import { isChunkLoadError, reloadOnceForChunkError } from '@utils/chunkReload';

interface Props {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // Stale tab after a deploy: the old chunk is gone, reload to fetch the new build.
        if (reloadOnceForChunkError(error)) return;
        // Log to error reporting service; avoid printing raw error to console
        // to prevent information disclosure in production.
        if (process.env.NODE_ENV !== 'production') {
            console.error('[ErrorBoundary]', error, info.componentStack);
        }
    }

    handleReset = () => {
        // Re-rendering with the old bundle cannot fix a missing chunk; a full reload can.
        if (this.state.error && isChunkLoadError(this.state.error)) {
            window.location.reload();
            return;
        }
        this.setState({ hasError: false, error: undefined });
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h2>Đã xảy ra lỗi</h2>
                    <p>Vui lòng thử lại hoặc liên hệ quản trị viên nếu lỗi tiếp tục xảy ra.</p>
                    <button onClick={this.handleReset} style={{ marginTop: '1rem', cursor: 'pointer' }}>
                        Thử lại
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
